import ForgotPasswordForm from '../components/forgot-password-form/forgot-password-form.component';

const ForgotPassword = () => {
    return(
        <div>
            <ForgotPasswordForm />
        </div>
    )
}

export default ForgotPassword;